module.exports = __webpack_public_path__ + "img/Isracard.453eae5d.svg";